// React
import React from 'react';

// Material UI Components
import {
    Typography,
    withStyles,
    Grid,
    Avatar, Box,
} from '@material-ui/core';

// Font Awesome Assets
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faBed, faCouch, faBuilding, faRuler, faPoundSign, faTimes, faPlus} from '@fortawesome/free-solid-svg-icons'
import { useState } from 'react';
import { useEffect } from 'react';
import Axios from 'axios';

// Custom Assets


const styles = theme => ({

    titleBoxOpen:{
        backgroundColor: '#90d3ff',
        paddingLeft:18,
        paddingRight:18
    },
    titleBoxClosed:{
        backgroundColor: '#90d3ff',
        paddingLeft:18,
        paddingRight:18
    },
    titleBoxText:{
        fontSize:24,
        [theme.breakpoints.down("sm")]: {
            fontSize: 21,
            lineHeight: 1.3,
            padding:10
        },
        fontWeight:600,
        color:theme.palette.primary.main,
        lineHeight: 2.5
    },
    titleBoxIcon:{
        fontSize:21,
        fontWeight:'bold',
        color:theme.palette.primary.main,
        fontFamily:"Cabin",
        [theme.breakpoints.down("sm")]: {
            fontSize: 16,
        },
    },
    expandableBody:{

        backgroundColor: '#ffffff'
    },
    panelOuter:{
        marginTop:20,
        marginBottom:30,
    },
    detailsTitle:{
        fontSize:21,
        color:theme.palette.primary.main,
        '& .detailPrice':{
            fontWeight:'bold'
        },
        '& .priceOverText':{
            fontWeight:'bold',
            fontStyle:'italic'
        },
        paddingBottom:20,
        borderBottom:'1px solid #e0d0e0',
        marginBottom:20,
        [theme.breakpoints.down("sm")]: {
            fontSize: 18,
            lineHeight: 1.5,
            padding:0
        },
    },
    propertyListDetails:{
        fontSize:18,
        lineHeight:'32px',
        [theme.breakpoints.down("sm")]: {
            fontSize:16,
        }
    },
    propertyListDetailsBold:{
        fontSize:'16px',
        fontWeight:'bold'
    },
    propertyBadge:{
        width:25,
        height:25,
        backgroundColor:theme.palette.primary.main,
        color:'#FFFFFF',
        '& .innerIcon':{
            fontSize:10
        }
    },
    bluePropertyAttribute:{
        fontSize:14,
        textTransform:'uppercase',
        color:theme.palette.primary.main,
        verticalAlign:'middle',
        lineHeight:'25px',
        paddingLeft:'0',
        marginLeft:-8,
        [theme.breakpoints.down("sm")]: {
            lineHeight:'18px',
        }

    },
    centrePropertyInfo:{
        backgroundColor:'#FFFFFF',
        paddingTop:35,
        paddingLeft:35,
        paddingRight:35,
        [theme.breakpoints.down("sm")]: {
            paddingTop:0,
            paddingLeft:10,
            paddingRight:10,
        }
    },
    rightPropertyInfo:{
        backgroundColor:'#FFFFFF',
        paddingBottom:20,
        paddingTop:85,
        paddingLeft:30,
        paddingRight:30,
        borderLeft:'1px solid #e0d0e0',
        [theme.breakpoints.down("sm")]: {
            paddingTop:20,
            paddingLeft:10,
            paddingRight:10,
        }
    }

});



class CollapsableProperty extends React.Component {




    constructor(props){
        super(props);
        this.state = {
            open: true
        }
        this.togglePanel = this.togglePanel.bind(this);
    }

    togglePanel(e){
        this.setState({open: !this.state.open})
    }

    componentDidUpdate(){

    }

    outputDate(str){
        if(str !== undefined){
            return (new Intl.DateTimeFormat("en-GB", {
                year: "numeric",
                month: "long",
                day: "2-digit"
            }).format(new Date(str)));
        }
        else{
            return '';
        }
    }

    outputCurrency(str){
        return  (new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'GBP',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        })).format(str);
    }





    render() {

        const { classes } = this.props;

        const sale = this.props.property;



        const { innerWidth: width, innerHeight: height } = window;
        const miniMobile = (width < 700);
        const bigWidth = (width > 900);

        return (
            <div className={classes.panelOuter}>
                <div onClick={(e)=>this.togglePanel(e)} className={this.state.open ? classes.titleBoxOpen : classes.titleBoxClosed}>
                    <Grid container>
                        <Grid item xs={11} sm>
                            <Typography className={classes.titleBoxText} width="100%">{this.props.property.address}</Typography>
                        </Grid>
                        <Grid item>
                            <Box display="flex" alignItems="center" height={'100%'}>
                                <Box>
                                    {this.state.open ?
                                        <FontAwesomeIcon className={classes.titleBoxIcon} icon={faTimes} />
                                        :
                                        <FontAwesomeIcon className={classes.titleBoxIcon} icon={faPlus} />
                                    }
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </div>
                {this.state.open ? (
                    <div className={classes.expandableBody}>
                        <Grid container>
                            {sale.thumbPath &&
                                <>
                                    {miniMobile ?
                                        <Grid xs={12} item>
                                            <div style={{height: '150px', width:'100%', overflow:'hidden'}}>
                                                <ThumbBox thumbPath={sale.thumbPath.split('?')[0]} style={{height: '130px', width:'100%'}} alt=""/>
                                            </div>
                                        </Grid>
                                        :
                                        <Grid item>
                                            <div style={{height: '290px'}}>
                                                <ThumbBox thumbPath={sale.thumbPath.split('?')[0]} alt="" style={{height:'290px'}}/>
                                            </div>
                                        </Grid>
                                    }
                                    </>
                            }
                            <Grid item xs={12} sm className={classes.centrePropertyInfo}>
                                <Typography className={classes.detailsTitle}>
                                    Sold Price: <span className="detailPrice"> {sale.sellingPrice !== '' ? this.outputCurrency(sale.sellingPrice) : 'Unknown Selling Price'}</span>
                                    {sale.overHR !== undefined &&
                                    <span className="priceOverText"> ({Math.abs(sale.overHR)}% {sale.overHR >=0 ? <>over</> : <>under</>} HR Value)</span>
                                    }
                                </Typography>
                                <Typography className={classes.propertyListDetails}>
                                    Market Date: <span className={classes.propertyListDetailsBold}> {this.outputDate(sale.dateOnMarket)}</span>
                                </Typography>
                                {sale.closingDate !== '' && sale.closingDate !== null ?
                                    <Typography className={classes.propertyListDetails}>
                                        Closing Date: <span className={classes.propertyListDetailsBold}>{this.outputDate(sale.closingDate)}</span>
                                    </Typography>: ''}
                                <Typography className={classes.propertyListDetails}>
                                    Concluded Date: <span className={classes.propertyListDetailsBold}>{this.outputDate(sale.dateSold)}</span>
                                </Typography>

                                <Typography className={classes.propertyListDetails}>
                                    {sale.priceQualifier}  <span className={classes.propertyListDetailsBold}>{this.outputCurrency(sale.askingPrice)}</span>
                                </Typography>
                                <Typography className={classes.propertyListDetails}>
                                    Home Report Value: <span className={classes.propertyListDetailsBold}>{this.outputCurrency(sale.hRValue)}</span>
                                </Typography>

                            </Grid>
                            <Grid item xs={miniMobile ? 12 : 0} className={classes.rightPropertyInfo}>
                                <Grid container spacing={2}>
                                    <Grid item>
                                        <Avatar className={classes.propertyBadge}>
                                            <FontAwesomeIcon className="innerIcon" icon={faBed}/>
                                        </Avatar>
                                    </Grid>
                                    <Grid item xs={8} sm>
                                        <Typography className={classes.bluePropertyAttribute}>
                                            {sale.bedrooms} Bedroom{sale.bedrooms > 1 ? 's' : ''}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item>
                                        <Avatar className={classes.propertyBadge}>
                                            <FontAwesomeIcon className="innerIcon" icon={faCouch}/>
                                        </Avatar>
                                    </Grid>
                                    <Grid item xs={8} sm>
                                        <Typography className={classes.bluePropertyAttribute}>
                                            {sale.publicRooms} Public Room{sale.publicRooms > 1 ? 's' : ''}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item>
                                        <Avatar className={classes.propertyBadge}>
                                            <FontAwesomeIcon className="innerIcon" icon={faBuilding}/>
                                        </Avatar>
                                    </Grid>
                                    <Grid item xs={8} sm>
                                        <Typography className={classes.bluePropertyAttribute}>
                                            {sale.propertyType}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item>
                                        <Avatar className={classes.propertyBadge}>
                                            <FontAwesomeIcon className="innerIcon" icon={faRuler}/>
                                        </Avatar>
                                    </Grid>
                                    <Grid item xs={8} sm>
                                        <Typography className={classes.bluePropertyAttribute}>
                                            {sale.sqm} sqm
                                            {sale.sqmP > 0 ? <> ({(new Intl.NumberFormat('en-GB', {
                                                style: 'currency',
                                                currency: 'GBP',
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 0
                                            })).format(sale.sqmP)}/sqm)</> : ''}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                {sale.councilTaxBand !== '' &&
                                <Grid container spacing={2}>
                                    <Grid item>
                                        <Avatar className={classes.propertyBadge}>
                                            <FontAwesomeIcon className="innerIcon" icon={faPoundSign}/>
                                        </Avatar>
                                    </Grid>
                                    <Grid item xs={8} sm>
                                        <Typography className={classes.bluePropertyAttribute}>
                                            Council Tax Band: {sale.councilTaxBand}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                }
                            </Grid>

                        </Grid>
                    </div>
                ) : null}
            </div>);
    }
}

const ThumbBox = React.memo((props) => {

    const {
        thumbPath='',
        isNeilsons,
        logoImg
    } = props;

    const [imageData, setImageData] = useState(null);

    const thumbPathUrlEncoded = encodeURIComponent(thumbPath);

    var apiUrl = process.env.REACT_APP_API_URL_START + window.location.hostname.substr(window.location.hostname.split('.')[0].length) + process.env.REACT_APP_API_URL_END;

    const apiPath = `${apiUrl}/propertythumb?path=${thumbPathUrlEncoded}`;

    useEffect(() => {
        if (!imageData) { // Check if imageData is already set
            Axios.get(apiPath, {
                timeout: 300000,
                withCredentials: true,
                responseType: 'blob'
            }).then((response) => {
                setImageData(URL.createObjectURL(response.data));
            })
            .catch((error) => {
                console.warn(error.message);
            });
        }
        /* eslint-disable */
    }, [apiPath, imageData]); // Add apiPath and imageData as dependencies
    /* eslint-enable */

    if(thumbPath){
        return (
        <Box className="imgResult" >
            <img src={imageData}  {...props}/>
        </Box>
        );
    }


    return null;
}, (prevProps, nextProps) => {
    // Custom comparison function
    return prevProps === nextProps;
}); 


export default withStyles(styles, { withTheme: true })(CollapsableProperty);